module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'ERROR' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'COULD_NOT_COMPLETE_PURCHASE' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";


/*****************
 ** WEBPACK FOOTER
 ** ./js/theme/paypal/error/view.html
 ** module id = 408
 ** module chunks = 0
 **/